import { BsFillFileEarmarkBarGraphFill } from 'react-icons/bs';
import { FaHandHoldingUsd, FaInfoCircle } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { IoSettings } from 'react-icons/io5';
import { MdDashboard, MdOutlineEmail, MdSwitchAccount } from 'react-icons/md';
import CSIcon from '../../../assets/images/CS-icon.svg';
import JournalIcon from '../../../assets/images/J-icon.svg';
import RefreshIcon from '../../../assets/images/refresh-icon.svg';

const IconHelper = ({ iconType, iconColor, className, toolTipId }) => {
  const Components = {};
  Components.FaInfoCircle = <FaInfoCircle color={iconColor} className={className} id={toolTipId} />;
  Components.MdOutlineEmail = <MdOutlineEmail color={iconColor} className={className} />;
  Components.FiDownload = <FiDownload color={iconColor} className={className} />;
  Components.MdSwitchAccount = <MdSwitchAccount color={iconColor} className="s-icon" />;
  Components.MdDashboard = <MdDashboard color={iconColor} className="s-icon" />;
  Components.JIcon = <img src={JournalIcon} className="s-icon" alt="" />;
  Components.CSIcon = <img src={CSIcon} className="s-icon" alt="" />;
  Components.RefreshIcon = <img src={RefreshIcon} className="s-icon" alt="" />;
  Components.FaHandHoldingUsd = <FaHandHoldingUsd color={iconColor} className="s-icon" />;
  Components.BsFillFileEarmarkBarGraphFill = (
    <BsFillFileEarmarkBarGraphFill color={iconColor} className="s-icon" />
  );
  Components.IoSettings = <IoSettings color={iconColor} className="s-icon" />;

  return Components[iconType];
};

export default IconHelper;
